<div class="custom-filter-popup">
  <div class="title">Number Filter</div>

  <div class="desc">Show rows where:</div>
  <hr class="custom-hr" />

  <div>
    <!-- 1st Filter -->
    <div class="filter-row">
      <div class="d-flex flex-column">
        <div class="desc">Filter</div>
        <mat-form-field class="type-filter">
          <mat-select [(ngModel)]="filter1Type">
            @for (filter of filter1Types; track filter) {
            <mat-option [value]="filter.value">{{ filter.viewValue }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="d-flex flex-column">
        <div class="desc">Number</div>
        <mat-form-field class="number-filter">
          <input
            matInput
            type="number"
            placeholder="Enter value"
            [(ngModel)]="filter1Number"
            step="1"
            style="width: 100%;"
            (keydown)="preventDecimal($event)"
            (keydown)="preventDecimal($event)"
          />
        </mat-form-field>
      </div>
    </div>

    <!-- Radio Buttons -->
    <div class="filter-row ps-5">
      <mat-radio-group
        [(ngModel)]="selectedToggle"
        (change)="selectedToggleChange($event)"
        class="radio-button-styles"
        style="width:75%; padding-top: 0.5%;"
        [disabled]="filter1Type === 'equals'"
      >
        <mat-radio-button color="primary" value="and">
          <span class="radio-button-font">And</span>
        </mat-radio-button>
        <mat-radio-button color="primary" class="radio-button-font" value="or">
          <span class="radio-button-font">Or</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- 2nd Filter -->
    <div class="filter-row">
      <div class="d-flex flex-column">
        <div class="desc">Filter</div>
        <mat-form-field class="type-filter">
          <mat-select [(ngModel)]="filter2Type" [disabled]="filter1Type === 'equals'">
            @for (filter of filter2Types; track filter) {
            <mat-option [value]="filter.value">{{ filter.viewValue }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="d-flex flex-column">
        <div class="desc">Number</div>
        <mat-form-field class="number-filter">
          <input
            matInput
            type="number"
            placeholder="Enter value"
            [(ngModel)]="filter2Number"
            style="width: 100%;"
            step="1"
            [disabled]="filter1Type === 'equals'"
            (keydown)="preventDecimal($event)"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <br />

  <span
    style="cursor:pointer; float: right;padding-right: 70px;color: #013b71 !important;"
    class="small localApplyButton"
    (click)="onApplyClick()"
    >Apply</span
  >
  <span
    style="cursor:pointer; float: right;padding-right: 22px;color: #013b71 !important;"
    class="small localApplyButton"
    (click)="onClearClick()"
    >Clear</span
  >
</div>
